// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2394a3b8%27 stroke-width=%272.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sort Menu Styles - Beautiful Mini Design */

/* Common sort container for all pages */
.orders-sort-container,
.users-sort-container,
.complaints-sort-container {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
  animation: none !important;
}

.sort-menu-wrapper {
  position: relative;
  display: inline-block;
}

.sort-menu-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 16px;
  background: var(--bg-primary);
  border: 1.5px solid #111; /* Darker border like in screenshot */
  border-radius: 12px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  color: #111;
  transition: background 0.2s ease, border-color 0.2s ease;
  min-height: 42px;
  white-space: nowrap;
  font-family: inherit;
  position: relative;
}

.sort-menu-button:hover {
  background: var(--bg-secondary);
  border-color: var(--accent-primary);
}

.sort-menu-button:focus,
.sort-menu-button:active {
  background: var(--bg-primary);
  border-color: var(--accent-primary);
  color: var(--accent-primary);
}

.sort-menu-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* Применены фильтры / сортировка не по умолчанию — синяя обводка и точка как в макете */
.sort-menu-button.filter-active {
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.35);
}

.sort-menu-button.filter-active::after {
  content: '';
  position: absolute;
  top: 6px;
  right: 6px;
  width: 8px;
  height: 8px;
  background: var(--accent-primary);
  border-radius: 50%;
  box-shadow: 0 0 0 2px var(--bg-primary);
  pointer-events: none;
}

/* Inline Select Style for Search Panels */
.inline-select-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.inline-select {
  appearance: none;
  background: var(--bg-secondary);
  border: 1.5px solid var(--border-color);
  border-radius: 10px;
  padding: 10px 32px 10px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;
  font-family: inherit;
  height: 40px;
  min-width: 140px;
  line-height: normal;
}

.inline-select:hover {
  background: var(--nav-hover-bg);
  color: #1e293b;
}

.inline-select:focus {
  outline: none;
  border-color: var(--accent-primary);
}

.inline-select-icon {
  position: absolute;
  right: 12px;
  pointer-events: none;
  color: #94a3b8;
  display: flex;
  align-items: center;
}

.sort-menu-icon,
.sort-menu-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--accent-primary); /* Icons and arrows are always blue */
  margin-left: 4px;
}

.sort-menu-button svg,
.sort-menu-label svg,
.sort-menu-arrow svg {
  color: var(--accent-primary);
  width: 16px;
  height: 16px;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.sort-menu-label {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--text-primary);
  font-weight: 600;
  letter-spacing: 0.3px;
}

.sort-menu-arrow svg.open {
  transform: rotate(180deg);
}

.sort-menu-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 240px;
  background: var(--bg-primary);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  border: 1px solid var(--border-color);
  border-radius: 16px;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  overflow: hidden;
  padding: 8px;
}

/* Orders: dropdown contains both sort + extra filters */
.orders-sort-filters-dropdown {
  left: auto;
  right: 0;
  width: 600px; /* Increased from 560px for better alignment in 2-column grid */
  min-width: 320px;
  max-width: calc(100vw - 2rem);
  max-height: calc(100vh - 120px);
  overflow-x: hidden;
  overflow-y: auto;
}

.orders-sort-filters-badge {
  top: 6px;
  right: 8px;
}

/* Keep titles minimal (no forced uppercase) */
.orders-sort-filters-dropdown .sort-menu-section-title {
  text-transform: none;
  letter-spacing: 0;
}

/* Minimal spacing inside the combined dropdown */
.orders-sort-filters-dropdown .more-filters-content {
  padding: 0;
  gap: 12px;
}

.orders-sort-filters-dropdown .orders-extra-filters-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 16px;
}

.orders-sort-filters-dropdown .users-extra-filters-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 16px;
  width: 100%;
}

.orders-sort-filters-dropdown .users-extra-filters-grid .more-filters-item,
.orders-sort-filters-dropdown .users-extra-filters-grid .cdp-wrapper {
  width: 100%;
  min-width: 0;
}

.orders-sort-filters-dropdown .users-extra-filters-grid .users-extra-filters-date {
  grid-column: 1 / -1;
}

.orders-sort-filters-dropdown .orders-extra-filters-grid,
.orders-sort-filters-dropdown .orders-extra-filters-grid .more-filters-item,
.orders-sort-filters-dropdown .orders-extra-filters-grid .sort-menu-wrapper {
  width: 100%;
  min-width: 0;
}

.orders-sort-filters-dropdown .orders-extra-filters-grid .sort-menu-button {
  width: 100%;
  min-width: 0 !important;
}

.orders-sort-filters-dropdown .orders-extra-filters-grid .sort-menu-dropdown {
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  transform: none !important;
}

.orders-sort-filters-dropdown .more-filters-item {
  gap: 6px;
}

.orders-sort-filters-dropdown .more-filters-label {
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .orders-sort-filters-dropdown {
    width: 100%;
    min-width: 0;
    max-width: 100%;
  }

  .orders-sort-filters-dropdown .orders-extra-filters-grid {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 12px;
  }

  .orders-sort-filters-dropdown .users-extra-filters-grid {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 12px;
  }

  .orders-sort-filters-dropdown .users-extra-filters-grid .users-extra-filters-date {
    grid-column: 1;
  }
}

.orders-sort-filters-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

/* Two equal columns: sort field + direction */
.orders-sort-main-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
}

.orders-sort-main-grid .sort-menu-section {
  padding-top: 16px;
  padding-bottom: 12px;
}

.orders-sort-main-grid .sort-menu-section + .sort-menu-section {
  border-left: 1px solid var(--border-color);
}

.orders-sort-main-grid .orders-sort-date-range {
  border-top: 1px solid var(--border-color);
  margin-top: 8px;
  padding-top: 6px;
  padding-bottom: 2px;
}

.orders-sort-date-range-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr); /* allow shrink to avoid width jumps */
  gap: 10px;
}

.orders-sort-date-range-grid .more-filters-item {
  gap: 4px;
  margin: 0;
  min-width: 0;
}

.orders-date-inline-title {
  margin: 0;
  padding: 0 4px;
  margin-bottom: 2px;
}

/* Status transition dates: label + from/to per row */
.orders-status-dates {
  border-top: 1px solid var(--border-color);
}

.orders-status-dates-row {
  display: grid;
  grid-template-columns: 110px minmax(0, 1fr) minmax(0, 1fr);
  align-items: end;
  gap: 10px;
  margin-top: 8px;
}

.orders-status-dates-row .more-filters-item {
  gap: 4px;
  margin: 0;
  min-width: 0;
}

.orders-status-dates-label {
  padding: 0 4px 10px;
  font-size: 0.9rem;
  color: var(--text-primary);
}

.sort-menu-section {
  padding: 12px;
}

.sort-menu-section:first-child {
  padding-top: 16px;
}

.sort-menu-section:last-child {
  padding-bottom: 16px;
}

.sort-menu-section-title {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #64748b;
  margin-bottom: 8px;
  padding: 0 4px;
}

.sort-menu-options {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sort-menu-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #475569;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
  text-align: left;
  width: 100%;
  font-family: inherit;
}

.sort-menu-option:hover {
  background: var(--nav-hover-bg);
  border-color: var(--border-color);
  color: #1e293b;
}

.sort-menu-option.active {
  background: var(--nav-active-bg, var(--nav-hover-bg));
  border-color: var(--accent-primary);
  color: var(--accent-primary);
  box-shadow: none;
}

.sort-menu-option.active:hover {
  background: var(--nav-active-bg, var(--nav-hover-bg));
  border-color: var(--accent-primary);
}

.sort-menu-option-icon {
  font-size: 16px;
  line-height: 1;
  font-weight: 600;
}

.sort-menu-option-label {
  flex: 1 1;
  font-weight: 500;
}

.orders-never-bought-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 4px;
}

.orders-never-bought-label {
  flex: 1 1;
  text-align: left;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #64748b;
}

.orders-switch {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  min-width: 0;
  width: 40px;
  pointer-events: none;
}

.orders-switch:hover {
}

.orders-switch.active {
  color: var(--accent-primary);
}

.orders-switch-text {
  font-size: 13px;
  font-weight: 600;
}

.orders-switch-track {
  width: 36px;
  height: 20px;
  border-radius: 999px;
  background: #cbd5e1;
  padding: 2px;
  display: inline-flex;
  align-items: center;
  transition: background 0.2s ease;
}

.orders-switch-thumb {
  width: 16px;
  height: 16px;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.2);
  transform: translateX(0);
  transition: transform 0.2s ease;
}

.orders-switch.active .orders-switch-track {
  background: var(--accent-primary);
}

.orders-switch.active .orders-switch-thumb {
  transform: translateX(16px);
}

/* Диапазон рейтинга при сортировке «По рейтингу» — компактные поля */
.sort-menu-rating-column {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.sort-menu-rating-range {
  display: flex;
  align-items: stretch;
  gap: 8px;
  width: 100%;
}

.sort-menu-rating-field {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.sort-menu-rating-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  padding: 0 2px;
  line-height: 1.2;
}

.sort-menu-rating-input {
  width: 100%;
  box-sizing: border-box;
  padding: 6px 8px;
  min-height: 0;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.25;
  color: #1e293b;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  font-family: inherit;
  -moz-appearance: textfield;
}

.sort-menu-rating-input::-webkit-outer-spin-button,
.sort-menu-rating-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.sort-menu-rating-input:hover {
  border-color: var(--accent-primary);
}

.sort-menu-rating-input:focus {
  outline: none;
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.12);
}

.sort-menu-rating-input::placeholder {
  color: #94a3b8;
  font-weight: 500;
  opacity: 1;
}

.sort-menu-option-check {
  font-size: 16px;
  font-weight: 700;
  color: var(--accent-primary);
  line-height: 1;
}

.sort-menu-option.active .sort-menu-option-check {
  animation: none !important;
}

@keyframes checkPop {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

.sort-menu-divider {
  height: 1px;
  background: linear-gradient(90deg, 
    transparent 0%, 
    #e2e8f0 20%, 
    #e2e8f0 80%, 
    transparent 100%
  );
  margin: 8px 12px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .sort-menu-dropdown {
    right: auto;
    left: 0;
    min-width: 220px;
  }

  .sort-menu-button {
    padding: 8px 14px;
    font-size: 13px;
  }

  .orders-sort-main-grid {
    grid-template-columns: 1fr;
  }

  .orders-status-dates-row {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }

  .orders-status-dates-label {
    grid-column: 1 / -1;
    padding-bottom: 0;
  }

  .orders-sort-main-grid .sort-menu-section + .sort-menu-section {
    border-left: none;
    border-top: 1px solid var(--border-color);
  }

  .orders-sort-date-range-grid {
    grid-template-columns: 1fr;
  }

  .orders-never-bought-row {
    justify-content: space-between;
    gap: 8px;
  }

  .orders-switch {
    width: 56px;
  }
}

@media (max-width: 480px) {
  .sort-menu-dropdown {
    min-width: 200px;
  }

  .orders-sort-filters-dropdown {
    left: 0;
    right: 0;
    width: 100%;
    max-width: 100%;
    padding: 6px;
  }

  .sort-menu-section {
    padding: 10px;
  }

  .sort-menu-option {
    padding: 8px 10px;
    font-size: 13px;
  }

  .orders-extra-filters-toggle {
    padding: 10px 12px;
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .orders-sort-filters-wrapper .sort-menu-button {
    width: 100%;
    justify-content: space-between;
  }
}

/* Extra Filters — Payload-style accordion */
.extra-filters-accordion {
  border: 1px solid var(--border-color);
  border-radius: 10px;
  overflow: visible;
  background: var(--bg-primary);
  margin-top: 8px;
}

.orders-extra-filters-toggle {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 16px;
  border: none;
  background: rgba(0, 0, 0, 0.02);
  border-bottom: 1px solid transparent;
  border-radius: 10px;
  cursor: pointer;
  color: #475569;
  font-weight: 600;
  font-family: inherit;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: background 0.2s ease, color 0.2s ease;
}

.orders-extra-filters-toggle:hover {
  background: rgba(0, 0, 0, 0.04);
  color: #1e293b;
}

.orders-extra-filters-toggle[aria-expanded="true"] {
  border-radius: 10px 10px 0 0;
  border-bottom-color: var(--border-color);
}

.orders-extra-filters-toggle-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
  color: var(--text-secondary);
}

.orders-extra-filters-toggle[aria-expanded="true"] .orders-extra-filters-toggle-icon {
  transform: rotate(180deg);
}

@keyframes allowOverflow {
  0% { overflow: hidden; }
  99% { overflow: hidden; }
  100% { overflow: visible; }
}

.orders-extra-filters-body {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  /* CustomDatePicker popover должен не обрезаться */
}

.orders-extra-filters-body.open {
  grid-template-rows: 1fr;
}

.orders-extra-filters-body.open > div {
  animation: allowOverflow 0.3s forwards;
}

.orders-extra-filters-body > div {
  overflow: hidden; /* Necessary for accordion exit animation */
}

/* Orders: popover календарей в dropdown */
.orders-sort-filters-dropdown .cdp-popover {
  left: 0 !important;
  right: auto !important;
  z-index: 2001;
  max-width: 100%;
}

/* More Filters Common Styles */
.more-filters-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.more-filters-label {
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
  padding: 0 4px;
}

.more-filters-input {
  appearance: none;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  width: 100%;
  cursor: pointer;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 40px;
}

.more-filters-input:hover {
  background-color: var(--bg-primary);
  border-color: var(--accent-primary);
}

.more-filters-input:focus {
  outline: none;
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Числовые поля (рейтинг): без стрелки select, без спиннеров */
.more-filters-input--number {
  background-image: none;
  padding-right: 14px;
  cursor: text;
  font-weight: 500;
  -moz-appearance: textfield;
}

.more-filters-input--number::-webkit-outer-spin-button,
.more-filters-input--number::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Premium Filter Toggle Switch */
.more-filters-checkbox-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}

.more-filters-checkbox-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 14px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease;
  -webkit-user-select: none;
          user-select: none;
  min-height: 42px;
}

.more-filters-checkbox-label:hover {
  background: var(--bg-primary);
  border-color: var(--accent-primary);
}

.more-filters-checkbox-text {
  font-size: 14px;
  font-weight: 600;
  color: #475569;
  transition: color 0.2s ease;
}

.more-filters-checkbox-label:hover .more-filters-checkbox-text {
  color: var(--accent-primary);
}

.more-filters-checkbox {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.custom-switch-track {
  position: relative;
  width: 38px;
  height: 20px;
  background-color: #e2e8f0;
  border-radius: 20px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.custom-switch-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 14px;
  height: 14px;
  background-color: white;
  border-radius: 50%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.more-filters-checkbox:checked + .more-filters-checkbox-label {
  background: var(--nav-active-bg, rgba(59, 130, 246, 0.05));
  border-color: var(--accent-primary);
}

.more-filters-checkbox:checked + .more-filters-checkbox-label .more-filters-checkbox-text {
  color: var(--accent-primary);
}

.more-filters-checkbox:checked + .more-filters-checkbox-label .custom-switch-track {
  background-color: var(--accent-primary);
}

.more-filters-checkbox:checked + .more-filters-checkbox-label .custom-switch-thumb {
  transform: translateX(18px);
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);
}

/* ============================================================
   ТЁМНАЯ ТЕМА (DEV): в меню сортировки/фильтров фон брался из
   токена (тёмный), а текст был захардкожен тёмным — сливался.
   ============================================================ */
:root[data-theme='dark'] .inline-select,
:root[data-theme='dark'] .sort-menu-option,
:root[data-theme='dark'] .more-filters-checkbox-text,
:root[data-theme='dark'] .orders-extra-filters-toggle {
  color: var(--text-secondary);
}

:root[data-theme='dark'] .inline-select:hover,
:root[data-theme='dark'] .sort-menu-option:hover,
:root[data-theme='dark'] .orders-extra-filters-toggle:hover,
:root[data-theme='dark'] .more-filters-input,
:root[data-theme='dark'] .sort-menu-rating-input {
  color: var(--text-primary);
}

/* Дорожка выключателя в выключенном состоянии — под тёмный фон */
:root[data-theme='dark'] .custom-switch-track {
  background-color: #334155;
}
`, "",{"version":3,"sources":["webpack://./src/css/sort-menu.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C,wCAAwC;AACxC;;;EAGE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB,EAAE,qCAAqC;EAC/D,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,wDAAwD;EACxD,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;;EAEE,6BAA6B;EAC7B,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA,wFAAwF;AACxF;EACE,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,uCAAuC;EACvC,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,wDAAwD;EACxD,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B,EAAE,qCAAqC;EACnE,gBAAgB;AAClB;;AAEA;;;EAGE,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,6BAA6B;EAC7B,qCAAqC;EACrC,mBAAmB;EACnB,oFAAoF;EACpF,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA,wDAAwD;AACxD;EACE,UAAU;EACV,QAAQ;EACR,YAAY,EAAE,+DAA+D;EAC7E,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA,8CAA8C;AAC9C;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,iDAAiD;AACjD;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,8BAA8B;EAC9B,MAAM;AACR;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC,EAAE,sCAAsC;EAC7E,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA,qDAAqD;AACrD;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yEAAyE;EACzE,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;EACN,YAAY;EACZ,WAAW;EACX,oBAAoB;AACtB;;AAEA;AACA;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,2CAA2C;EAC3C,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX;;;;;GAKC;EACD,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,OAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,yCAAyC;EAC3C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,OAAO;IACP,QAAQ;IACR,WAAW;IACX,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,8BAA8B;EAChC;AACF;;AAEA,4CAA4C;AAC5C;EACE,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,KAAK,gBAAgB,EAAE;EACvB,MAAM,gBAAgB,EAAE;EACxB,OAAO,iBAAiB,EAAE;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gEAAgE;EAChE,kDAAkD;AACpD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB,EAAE,2CAA2C;AAC/D;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,wDAAwD;EACxD,WAAW;EACX,eAAe;EACf,yDAAmS;EACnS,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA,+DAA+D;AAC/D;EACE,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,wDAAwD;EACxD,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;EACE,0DAA0D;EAC1D,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;;;iEAGiE;AACjE;;;;EAIE,4BAA4B;AAC9B;;AAEA;;;;;EAKE,0BAA0B;AAC5B;;AAEA,iEAAiE;AACjE;EACE,yBAAyB;AAC3B","sourcesContent":["/* Sort Menu Styles - Beautiful Mini Design */\n\n/* Common sort container for all pages */\n.orders-sort-container,\n.users-sort-container,\n.complaints-sort-container {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 16px;\n  animation: none !important;\n}\n\n.sort-menu-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.sort-menu-button {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 10px 16px;\n  background: var(--bg-primary);\n  border: 1.5px solid #111; /* Darker border like in screenshot */\n  border-radius: 12px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 700;\n  color: #111;\n  transition: background 0.2s ease, border-color 0.2s ease;\n  min-height: 42px;\n  white-space: nowrap;\n  font-family: inherit;\n  position: relative;\n}\n\n.sort-menu-button:hover {\n  background: var(--bg-secondary);\n  border-color: var(--accent-primary);\n}\n\n.sort-menu-button:focus,\n.sort-menu-button:active {\n  background: var(--bg-primary);\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n}\n\n.sort-menu-button:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n/* Применены фильтры / сортировка не по умолчанию — синяя обводка и точка как в макете */\n.sort-menu-button.filter-active {\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.35);\n}\n\n.sort-menu-button.filter-active::after {\n  content: '';\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  width: 8px;\n  height: 8px;\n  background: var(--accent-primary);\n  border-radius: 50%;\n  box-shadow: 0 0 0 2px var(--bg-primary);\n  pointer-events: none;\n}\n\n/* Inline Select Style for Search Panels */\n.inline-select-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.inline-select {\n  appearance: none;\n  background: var(--bg-secondary);\n  border: 1.5px solid var(--border-color);\n  border-radius: 10px;\n  padding: 10px 32px 10px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #475569;\n  cursor: pointer;\n  transition: border-color 0.2s ease, background 0.2s ease;\n  font-family: inherit;\n  height: 40px;\n  min-width: 140px;\n  line-height: normal;\n}\n\n.inline-select:hover {\n  background: var(--nav-hover-bg);\n  color: #1e293b;\n}\n\n.inline-select:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n}\n\n.inline-select-icon {\n  position: absolute;\n  right: 12px;\n  pointer-events: none;\n  color: #94a3b8;\n  display: flex;\n  align-items: center;\n}\n\n.sort-menu-icon,\n.sort-menu-arrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--accent-primary); /* Icons and arrows are always blue */\n  margin-left: 4px;\n}\n\n.sort-menu-button svg,\n.sort-menu-label svg,\n.sort-menu-arrow svg {\n  color: var(--accent-primary);\n  width: 16px;\n  height: 16px;\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.sort-menu-label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--text-primary);\n  font-weight: 600;\n  letter-spacing: 0.3px;\n}\n\n.sort-menu-arrow svg.open {\n  transform: rotate(180deg);\n}\n\n.sort-menu-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  min-width: 240px;\n  background: var(--bg-primary);\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n  border: 1px solid var(--border-color);\n  border-radius: 16px;\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.05);\n  z-index: 1000;\n  overflow: hidden;\n  padding: 8px;\n}\n\n/* Orders: dropdown contains both sort + extra filters */\n.orders-sort-filters-dropdown {\n  left: auto;\n  right: 0;\n  width: 600px; /* Increased from 560px for better alignment in 2-column grid */\n  min-width: 320px;\n  max-width: calc(100vw - 2rem);\n  max-height: calc(100vh - 120px);\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.orders-sort-filters-badge {\n  top: 6px;\n  right: 8px;\n}\n\n/* Keep titles minimal (no forced uppercase) */\n.orders-sort-filters-dropdown .sort-menu-section-title {\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n/* Minimal spacing inside the combined dropdown */\n.orders-sort-filters-dropdown .more-filters-content {\n  padding: 0;\n  gap: 12px;\n}\n\n.orders-sort-filters-dropdown .orders-extra-filters-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  padding: 16px;\n}\n\n.orders-sort-filters-dropdown .users-extra-filters-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  padding: 16px;\n  width: 100%;\n}\n\n.orders-sort-filters-dropdown .users-extra-filters-grid .more-filters-item,\n.orders-sort-filters-dropdown .users-extra-filters-grid .cdp-wrapper {\n  width: 100%;\n  min-width: 0;\n}\n\n.orders-sort-filters-dropdown .users-extra-filters-grid .users-extra-filters-date {\n  grid-column: 1 / -1;\n}\n\n.orders-sort-filters-dropdown .orders-extra-filters-grid,\n.orders-sort-filters-dropdown .orders-extra-filters-grid .more-filters-item,\n.orders-sort-filters-dropdown .orders-extra-filters-grid .sort-menu-wrapper {\n  width: 100%;\n  min-width: 0;\n}\n\n.orders-sort-filters-dropdown .orders-extra-filters-grid .sort-menu-button {\n  width: 100%;\n  min-width: 0 !important;\n}\n\n.orders-sort-filters-dropdown .orders-extra-filters-grid .sort-menu-dropdown {\n  left: 0 !important;\n  right: 0 !important;\n  width: 100% !important;\n  min-width: 100% !important;\n  max-width: 100% !important;\n  transform: none !important;\n}\n\n.orders-sort-filters-dropdown .more-filters-item {\n  gap: 6px;\n}\n\n.orders-sort-filters-dropdown .more-filters-label {\n  margin-bottom: 0;\n}\n\n@media (max-width: 768px) {\n  .orders-sort-filters-dropdown {\n    width: 100%;\n    min-width: 0;\n    max-width: 100%;\n  }\n\n  .orders-sort-filters-dropdown .orders-extra-filters-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n    padding: 12px;\n  }\n\n  .orders-sort-filters-dropdown .users-extra-filters-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n    padding: 12px;\n  }\n\n  .orders-sort-filters-dropdown .users-extra-filters-grid .users-extra-filters-date {\n    grid-column: 1;\n  }\n}\n\n.orders-sort-filters-wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n}\n\n/* Two equal columns: sort field + direction */\n.orders-sort-main-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0;\n}\n\n.orders-sort-main-grid .sort-menu-section {\n  padding-top: 16px;\n  padding-bottom: 12px;\n}\n\n.orders-sort-main-grid .sort-menu-section + .sort-menu-section {\n  border-left: 1px solid var(--border-color);\n}\n\n.orders-sort-main-grid .orders-sort-date-range {\n  border-top: 1px solid var(--border-color);\n  margin-top: 8px;\n  padding-top: 6px;\n  padding-bottom: 2px;\n}\n\n.orders-sort-date-range-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr); /* allow shrink to avoid width jumps */\n  gap: 10px;\n}\n\n.orders-sort-date-range-grid .more-filters-item {\n  gap: 4px;\n  margin: 0;\n  min-width: 0;\n}\n\n.orders-date-inline-title {\n  margin: 0;\n  padding: 0 4px;\n  margin-bottom: 2px;\n}\n\n/* Status transition dates: label + from/to per row */\n.orders-status-dates {\n  border-top: 1px solid var(--border-color);\n}\n\n.orders-status-dates-row {\n  display: grid;\n  grid-template-columns: 110px minmax(0, 1fr) minmax(0, 1fr);\n  align-items: end;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.orders-status-dates-row .more-filters-item {\n  gap: 4px;\n  margin: 0;\n  min-width: 0;\n}\n\n.orders-status-dates-label {\n  padding: 0 4px 10px;\n  font-size: 0.9rem;\n  color: var(--text-primary);\n}\n\n.sort-menu-section {\n  padding: 12px;\n}\n\n.sort-menu-section:first-child {\n  padding-top: 16px;\n}\n\n.sort-menu-section:last-child {\n  padding-bottom: 16px;\n}\n\n.sort-menu-section-title {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #64748b;\n  margin-bottom: 8px;\n  padding: 0 4px;\n}\n\n.sort-menu-options {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.sort-menu-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 12px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  color: #475569;\n  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n  text-align: left;\n  width: 100%;\n  font-family: inherit;\n}\n\n.sort-menu-option:hover {\n  background: var(--nav-hover-bg);\n  border-color: var(--border-color);\n  color: #1e293b;\n}\n\n.sort-menu-option.active {\n  background: var(--nav-active-bg, var(--nav-hover-bg));\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n  box-shadow: none;\n}\n\n.sort-menu-option.active:hover {\n  background: var(--nav-active-bg, var(--nav-hover-bg));\n  border-color: var(--accent-primary);\n}\n\n.sort-menu-option-icon {\n  font-size: 16px;\n  line-height: 1;\n  font-weight: 600;\n}\n\n.sort-menu-option-label {\n  flex: 1;\n  font-weight: 500;\n}\n\n.orders-never-bought-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 4px;\n}\n\n.orders-never-bought-label {\n  flex: 1;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.orders-switch {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0;\n  min-width: 0;\n  width: 40px;\n  pointer-events: none;\n}\n\n.orders-switch:hover {\n}\n\n.orders-switch.active {\n  color: var(--accent-primary);\n}\n\n.orders-switch-text {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.orders-switch-track {\n  width: 36px;\n  height: 20px;\n  border-radius: 999px;\n  background: #cbd5e1;\n  padding: 2px;\n  display: inline-flex;\n  align-items: center;\n  transition: background 0.2s ease;\n}\n\n.orders-switch-thumb {\n  width: 16px;\n  height: 16px;\n  border-radius: 999px;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.2);\n  transform: translateX(0);\n  transition: transform 0.2s ease;\n}\n\n.orders-switch.active .orders-switch-track {\n  background: var(--accent-primary);\n}\n\n.orders-switch.active .orders-switch-thumb {\n  transform: translateX(16px);\n}\n\n/* Диапазон рейтинга при сортировке «По рейтингу» — компактные поля */\n.sort-menu-rating-column {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.sort-menu-rating-range {\n  display: flex;\n  align-items: stretch;\n  gap: 8px;\n  width: 100%;\n}\n\n.sort-menu-rating-field {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.sort-menu-rating-label {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #64748b;\n  padding: 0 2px;\n  line-height: 1.2;\n}\n\n.sort-menu-rating-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 6px 8px;\n  min-height: 0;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.25;\n  color: #1e293b;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  font-family: inherit;\n  -moz-appearance: textfield;\n}\n\n.sort-menu-rating-input::-webkit-outer-spin-button,\n.sort-menu-rating-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.sort-menu-rating-input:hover {\n  border-color: var(--accent-primary);\n}\n\n.sort-menu-rating-input:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.12);\n}\n\n.sort-menu-rating-input::placeholder {\n  color: #94a3b8;\n  font-weight: 500;\n  opacity: 1;\n}\n\n.sort-menu-option-check {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--accent-primary);\n  line-height: 1;\n}\n\n.sort-menu-option.active .sort-menu-option-check {\n  animation: none !important;\n}\n\n@keyframes checkPop {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    transform: scale(1.2);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.sort-menu-divider {\n  height: 1px;\n  background: linear-gradient(90deg, \n    transparent 0%, \n    #e2e8f0 20%, \n    #e2e8f0 80%, \n    transparent 100%\n  );\n  margin: 8px 12px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .sort-menu-dropdown {\n    right: auto;\n    left: 0;\n    min-width: 220px;\n  }\n\n  .sort-menu-button {\n    padding: 8px 14px;\n    font-size: 13px;\n  }\n\n  .orders-sort-main-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .orders-status-dates-row {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n\n  .orders-status-dates-label {\n    grid-column: 1 / -1;\n    padding-bottom: 0;\n  }\n\n  .orders-sort-main-grid .sort-menu-section + .sort-menu-section {\n    border-left: none;\n    border-top: 1px solid var(--border-color);\n  }\n\n  .orders-sort-date-range-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .orders-never-bought-row {\n    justify-content: space-between;\n    gap: 8px;\n  }\n\n  .orders-switch {\n    width: 56px;\n  }\n}\n\n@media (max-width: 480px) {\n  .sort-menu-dropdown {\n    min-width: 200px;\n  }\n\n  .orders-sort-filters-dropdown {\n    left: 0;\n    right: 0;\n    width: 100%;\n    max-width: 100%;\n    padding: 6px;\n  }\n\n  .sort-menu-section {\n    padding: 10px;\n  }\n\n  .sort-menu-option {\n    padding: 8px 10px;\n    font-size: 13px;\n  }\n\n  .orders-extra-filters-toggle {\n    padding: 10px 12px;\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .orders-sort-filters-wrapper .sort-menu-button {\n    width: 100%;\n    justify-content: space-between;\n  }\n}\n\n/* Extra Filters — Payload-style accordion */\n.extra-filters-accordion {\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  overflow: visible;\n  background: var(--bg-primary);\n  margin-top: 8px;\n}\n\n.orders-extra-filters-toggle {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 12px 16px;\n  border: none;\n  background: rgba(0, 0, 0, 0.02);\n  border-bottom: 1px solid transparent;\n  border-radius: 10px;\n  cursor: pointer;\n  color: #475569;\n  font-weight: 600;\n  font-family: inherit;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.orders-extra-filters-toggle:hover {\n  background: rgba(0, 0, 0, 0.04);\n  color: #1e293b;\n}\n\n.orders-extra-filters-toggle[aria-expanded=\"true\"] {\n  border-radius: 10px 10px 0 0;\n  border-bottom-color: var(--border-color);\n}\n\n.orders-extra-filters-toggle-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.3s ease;\n  color: var(--text-secondary);\n}\n\n.orders-extra-filters-toggle[aria-expanded=\"true\"] .orders-extra-filters-toggle-icon {\n  transform: rotate(180deg);\n}\n\n@keyframes allowOverflow {\n  0% { overflow: hidden; }\n  99% { overflow: hidden; }\n  100% { overflow: visible; }\n}\n\n.orders-extra-filters-body {\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: grid-template-rows 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  /* CustomDatePicker popover должен не обрезаться */\n}\n\n.orders-extra-filters-body.open {\n  grid-template-rows: 1fr;\n}\n\n.orders-extra-filters-body.open > div {\n  animation: allowOverflow 0.3s forwards;\n}\n\n.orders-extra-filters-body > div {\n  overflow: hidden; /* Necessary for accordion exit animation */\n}\n\n/* Orders: popover календарей в dropdown */\n.orders-sort-filters-dropdown .cdp-popover {\n  left: 0 !important;\n  right: auto !important;\n  z-index: 2001;\n  max-width: 100%;\n}\n\n/* More Filters Common Styles */\n.more-filters-item {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.more-filters-label {\n  font-size: 12px;\n  font-weight: 700;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 2px;\n  padding: 0 4px;\n}\n\n.more-filters-input {\n  appearance: none;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  padding: 10px 14px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1e293b;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  width: 100%;\n  cursor: pointer;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  padding-right: 40px;\n}\n\n.more-filters-input:hover {\n  background-color: var(--bg-primary);\n  border-color: var(--accent-primary);\n}\n\n.more-filters-input:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n/* Числовые поля (рейтинг): без стрелки select, без спиннеров */\n.more-filters-input--number {\n  background-image: none;\n  padding-right: 14px;\n  cursor: text;\n  font-weight: 500;\n  -moz-appearance: textfield;\n}\n\n.more-filters-input--number::-webkit-outer-spin-button,\n.more-filters-input--number::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Premium Filter Toggle Switch */\n.more-filters-checkbox-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n}\n\n.more-filters-checkbox-label {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 10px 14px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease;\n  user-select: none;\n  min-height: 42px;\n}\n\n.more-filters-checkbox-label:hover {\n  background: var(--bg-primary);\n  border-color: var(--accent-primary);\n}\n\n.more-filters-checkbox-text {\n  font-size: 14px;\n  font-weight: 600;\n  color: #475569;\n  transition: color 0.2s ease;\n}\n\n.more-filters-checkbox-label:hover .more-filters-checkbox-text {\n  color: var(--accent-primary);\n}\n\n.more-filters-checkbox {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.custom-switch-track {\n  position: relative;\n  width: 38px;\n  height: 20px;\n  background-color: #e2e8f0;\n  border-radius: 20px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.custom-switch-thumb {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 14px;\n  height: 14px;\n  background-color: white;\n  border-radius: 50%;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);\n}\n\n.more-filters-checkbox:checked + .more-filters-checkbox-label {\n  background: var(--nav-active-bg, rgba(59, 130, 246, 0.05));\n  border-color: var(--accent-primary);\n}\n\n.more-filters-checkbox:checked + .more-filters-checkbox-label .more-filters-checkbox-text {\n  color: var(--accent-primary);\n}\n\n.more-filters-checkbox:checked + .more-filters-checkbox-label .custom-switch-track {\n  background-color: var(--accent-primary);\n}\n\n.more-filters-checkbox:checked + .more-filters-checkbox-label .custom-switch-thumb {\n  transform: translateX(18px);\n  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);\n}\n\n/* ============================================================\n   ТЁМНАЯ ТЕМА (DEV): в меню сортировки/фильтров фон брался из\n   токена (тёмный), а текст был захардкожен тёмным — сливался.\n   ============================================================ */\n:root[data-theme='dark'] .inline-select,\n:root[data-theme='dark'] .sort-menu-option,\n:root[data-theme='dark'] .more-filters-checkbox-text,\n:root[data-theme='dark'] .orders-extra-filters-toggle {\n  color: var(--text-secondary);\n}\n\n:root[data-theme='dark'] .inline-select:hover,\n:root[data-theme='dark'] .sort-menu-option:hover,\n:root[data-theme='dark'] .orders-extra-filters-toggle:hover,\n:root[data-theme='dark'] .more-filters-input,\n:root[data-theme='dark'] .sort-menu-rating-input {\n  color: var(--text-primary);\n}\n\n/* Дорожка выключателя в выключенном состоянии — под тёмный фон */\n:root[data-theme='dark'] .custom-switch-track {\n  background-color: #334155;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
